import React from "react";
import GetInTouchSection from "../common/GetInTouch/GetInTouchSection";
import BacktoTopCom from "../helpers/BackToTopCom";
import Layouts from "../helpers/Layouts";
import ServiceInfo from "./Services/ServiceInfo";

export default function ServicesLayout({
  background,
  children,
  pageTitle,
  breadcrumbs,
  metaTag,
}) {
  return (
    <Layouts background={background} pageTitle={pageTitle} breadcrumbs={breadcrumbs} metaTag={metaTag}>
      {children && children}
      <ServiceInfo />
      <GetInTouchSection />
      <BacktoTopCom />
    </Layouts>
  );
}
